export default __webpack_public_path__ + "static/media/hammer-icon.cad7a704.svg";